module.exports = __webpack_public_path__ + "public/img/yc.ae235104.png";